import Axios from "axios";
import {initBlacklistForm} from "./form";
import {loading, stopLoading} from "../../helpers/loading";
import {handleAjaxSuccess} from "../../helpers/swalHelper";
import handleAjaxError from "../../helpers/handleAjaxError";

function initBlacklistIndex() {
	document.querySelector('.update-blacklist-button').onclick = updateBlacklist;

	const form = initBlacklistForm(document.querySelector('.blacklist-form'));

	/**
	 * Methods
	 */

	function updateBlacklist() {
		const data = form.inputs();

		form.clearFeedbacks();
		form.clearLineErrors();

		loading();

		Axios.post(form.postUrl(), data)
			.then(handleAjaxSuccess)
			.catch(error => {
				handleAjaxError(error);

				// Check if we can highlight the error
				form.displayWrongLine();
			})
			.finally(stopLoading)
	}
}

export {initBlacklistIndex}
